import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextField from 'components/Input/CustomTextField';
import CustomButton from 'components/CustomInput/Button';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobal } from 'store/global/reducer';
import styled from 'styled-components/macro';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import TextHeader from 'components/CustomText/TextHeader';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';
import { APPLICATION_LIST_REFRESH } from 'store/key';
import useDialog from 'components/ConfirmDialog/useDialog';
import { EXPIRY_DATE_UPDATED } from 'utility/frontendMessage';
import { INIT_APPLICATION } from 'utility/postApprovalLookUp';

const SLayout = styled.div``;

const SInputColumn = styled.div`
    width: 100%;
    margin-top: 20px;
`;

const ExpireExtensionFormModal = ({ open }) => {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const appId = useSelector((state) => state.global.appId);
    const originalExpiryDate = useSelector((state) => state.global.originalExpiryDate);
    const callback = useSelector((state) => state.global.callback);

    const documentType = useSelector((state) => state.global.documentType);

    const [expiryDate, setExpiryDate] = useState(null);
    const [reason, setReason] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [commentValid, setCommentValid] = useState(true);
    const [forceShowError, setForceShowError] = useState(false);

    useEffect(() => {
        if (open) {
            setExpiryDate(null);
            setReason('');
            setIsValid(true);
            setForceShowError(false);
            setCommentValid(true);
        }
    }, [open]);

    const onSubmit = () => {
        setForceShowError(true);
        if (isValid && commentValid) {
            setGlobalLoading(true);
            API.application
                .changeExpiryDate({
                    data: {
                        documentId: appId,
                        documentType,
                        expiryDate: new Date(expiryDate),
                        reason: reason,
                    },
                })
                .then(async () => {
                    setGlobalLoading(false);
                    const confirmAction = await showDialog({
                        description: EXPIRY_DATE_UPDATED,
                        disableCancelButton: true,
                    });
                    if (confirmAction) {
                        if (documentType !== INIT_APPLICATION) {
                            callback?.();
                        } else {
                            dispatch({
                                type: APPLICATION_LIST_REFRESH,
                            });
                        }
                        onClose();
                    }
                })
                .finally(() => {
                    setGlobalLoading(false);
                });
        }
    };

    const onClose = () => {
        dispatch(
            setGlobal({
                isExtensionFormOpen: false,
                appId: null,
                originalExpiryDate: null,
            }),
        );
    };

    return (
        <SLayout>
            <Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <DialogTitle>
                    <TextHeader>
                        Expiry period of {documentType === INIT_APPLICATION ? 'initial application' : 'post approval document'}
                        </TextHeader>
                </DialogTitle>

                <DialogContent style={{ padding: '0 20px 20px 20px' }}>
                    <SInputColumn>Original Expiry Date: {originalExpiryDate}</SInputColumn>

                    <SInputColumn>
                        <CustomDatePicker
                            label={'New Expiry Date'}
                            value={expiryDate}
                            onChange={(date) => {
                                setExpiryDate(date);
                            }}
                            isValidValue={(isValid) => {
                                setIsValid(isValid);
                            }}
                            validators={['isRequired']}
                            forceErrorDisplay={forceShowError}
                        />
                    </SInputColumn>
                    <SInputColumn>
                        <CustomTextField
                            isTextArea
                            label={'Remarks for amendment'}
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            maxLength={255}
                            isValidValue={(valid) => setCommentValid(valid)}
                            forceErrorDisplay={true}
                        />
                    </SInputColumn>
                </DialogContent>
                <DialogActions>
                    <CustomButton type={'cancel'} onClick={onClose} color="primary">
                        Cancel
                    </CustomButton>
                    <CustomButton onClick={onSubmit} autoFocus>
                        Confirm
                    </CustomButton>
                </DialogActions>
            </Dialog>
        </SLayout>
    );
};

export default ExpireExtensionFormModal;
